import { useContext } from 'react'

import { AuthContext } from 'contexts'

import { appsListUnion } from 'config/apps'

export const appletList = [
  'covid-science360',
  'covid-commercial',
  'epidemiology',
  'influenza-science360',
  'influenza-commercial',
  'influenza-epidemiology',
  'rsv-science360',
  'rsv-epidemiology',
  'rsv-commercial',
  'cardio-science360',
  'internal-tooling',
  'pad',
  'biorisk',
  'ida-360',
  'botulism',
] as const
export type appletListUnion = (typeof appletList)[number]

export type AppletConfig = {
  key: appletListUnion
  name: string
  apps: appsListUnion[]
}

export const applets: Record<appletListUnion, AppletConfig> = {
  /* -------------------------------------------------------------------------- */
  /*                                  COVID-19                                  */
  /* -------------------------------------------------------------------------- */
  'covid-science360': {
    key: 'covid-science360',
    name: 'Science360',
    apps: ['covid-19-vaccines', 'covid-19-therapeutics'],
  },
  'covid-commercial': {
    key: 'covid-commercial',
    name: 'Commercial',
    apps: ['covid-19-commercial-vaccines', 'covid-19-commercial-therapeutics'],
  },
  epidemiology: {
    key: 'epidemiology',
    name: 'Epidemiology',
    apps: ['epidemiology'],
  },
  /* -------------------------------------------------------------------------- */
  /*                                  INFLUENZA                                 */
  /* -------------------------------------------------------------------------- */
  'influenza-science360': {
    key: 'influenza-science360',
    name: 'Science360',
    apps: ['influenza'],
  },
  'influenza-commercial': {
    key: 'influenza-commercial',
    name: 'Commercial',
    apps: ['influenza-commercial'],
  },
  'influenza-epidemiology': {
    key: 'influenza-epidemiology',
    name: 'Epidemiology',
    apps: ['influenza-epidemiology'],
  },
  /* -------------------------------------------------------------------------- */
  /*                                     RSV                                    */
  /* -------------------------------------------------------------------------- */
  'rsv-science360': {
    key: 'rsv-science360',
    name: 'Science360',
    apps: ['rsv'],
  },
  'rsv-epidemiology': {
    key: 'rsv-epidemiology',
    name: 'Epidemiology',
    apps: ['rsv-epidemiology'],
  },
  'rsv-commercial': {
    key: 'rsv-commercial',
    name: 'Commercial',
    apps: ['rsv-commercial'],
  },
  /* -------------------------------------------------------------------------- */
  /*                                   Cardio                                   */
  /* -------------------------------------------------------------------------- */
  'cardio-science360': {
    key: 'cardio-science360',
    name: 'Science360',
    apps: ['cardio-lipid'],
  },
  /* -------------------------------------------------------------------------- */
  /*                                     Pad                                    */
  /* -------------------------------------------------------------------------- */
  pad: {
    key: 'pad',
    name: 'Pandemic Antiviral Discovery',
    apps: ['pad'],
  },
  /*                             Pandemic Preparedness                          */
  /* -------------------------------------------------------------------------- */
  biorisk: {
    key: 'biorisk',
    name: 'Biorisk',
    apps: ['biorisk'],
  },
  botulism: {
    key: 'botulism',
    name: 'Botulism',
    apps: ['botulism'],
  },
  /* -------------------------------------------------------------------------- */
  /*                                  Internal                                  */
  /* -------------------------------------------------------------------------- */
  'internal-tooling': {
    key: 'internal-tooling',
    name: 'Internal Tooling',
    apps: ['internal-tooling'],
  },
  /* -------------------------------------------------------------------------- */
  /*                                  IDA - Infectious Disease Analytics                                   */
  /* -------------------------------------------------------------------------- */
  'ida-360': {
    key: 'ida-360',
    name: 'IDA - Infectious Disease Analytics',
    apps: ['ida-360'],
  },
}

// Theoretically, it is possible to have an app in multiple applets. In this case, we always get the first one
export const useAppletFromApp = (appSlug: appsListUnion) => {
  const { appletsUserCanSee } = useContext(AuthContext)

  return Object.values(appletsUserCanSee).find((applet) =>
    applet.apps.includes(appSlug)
  )
}
